import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkout-footer',
  templateUrl: './checkout-footer.component.html',
  styleUrls: ['./checkout-footer.component.css'],
})
export class CheckoutFooterComponent {
  @Input() total = 0;
  @Output() checkout = new EventEmitter<void>();
}
